/* Verolae · Three pillar
   Port of the source site "mb_three_piller" inline script: on mobile the card grid is a
   horizontal scroll-snap carousel; the dots follow the scroll position and clicking a dot
   scrolls to that card. Dependency-free. Guards against multiple instances and re-runs
   when the theme editor (re)loads a section. */
(function () {
  'use strict';

  function initPillars(root) {
    if (!root || root.getAttribute('data-mb-pillars-init') === 'true') return;

    var track = root.querySelector('.mb-pillars__grid');
    var dotsWrap = root.querySelector('.mb-pillars__dots');
    if (!track) return;

    root.setAttribute('data-mb-pillars-init', 'true');

    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.mb-pillars__dot')) : [];
    var cards = track.querySelectorAll('.mb-pillars__card');
    var total = cards.length;
    if (total < 2) return;

    function cardStep() {
      return cards[0].offsetWidth + (parseInt(getComputedStyle(track).columnGap, 10) || 0);
    }

    /* Update active dot based on scroll position */
    function getActiveIndex() {
      return Math.round(track.scrollLeft / cardStep());
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function scrollToCard(index) {
      track.scrollTo({ left: cardStep() * index, behavior: 'smooth' });
    }

    /* Scroll listener with debounce */
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        setActiveDot(getActiveIndex());
      }, 60);
    }, { passive: true });

    /* Dot click: scroll to card */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToCard(parseInt(dot.getAttribute('data-index'), 10) || 0);
      });
    });

    root.mbPillarsScrollToCard = scrollToCard;
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.mb-pillars[data-mb-pillars]');
    Array.prototype.forEach.call(nodes, initPillars);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: (re)initialise a freshly loaded section and follow block selection on mobile */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target;
    if (!card || !card.classList || !card.classList.contains('mb-pillars__card')) return;
    var root = card.closest('.mb-pillars[data-mb-pillars]');
    if (!root || typeof root.mbPillarsScrollToCard !== 'function') return;
    var track = card.parentElement;
    if (!track || getComputedStyle(track).display !== 'flex') return;
    root.mbPillarsScrollToCard(parseInt(card.getAttribute('data-index'), 10) || 0);
  });
})();
